
export default {
    name: 'BusinessLicenceForm',
    props: {
        form: {
            type: Object,
            required: true,
        },
        isEditForm: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            agencyOptions: [
                { name: this.$t('business.agencies.ea'), slug: 'ea' },
                { name: this.$t('business.agencies.iepa'), slug: 'iepa' },
                { name: this.$t('business.agencies.sepa'), slug: 'sepa' },
                { name: this.$t('business.agencies.nr'), slug: 'nr' },
                { name: this.$t('business.agencies.niea'), slug: 'niea' },
            ],
        };
    },
};
